<template>
    <section class="bg-dark pb-3 pt-5">
        <div class="container py-5">
            <div class="row align-items-center mt-2 mt-md-0 pt-md-4 py-lg-2">
                <div class="col-md-8 offset-md-2 order-md-1 text-center">
                    <h1 class="display-5 pt-2 text-light pb-0 mb-4 mb-lg-4">Welcome to <span class="text-primary">{{
                        whitelabelConfiguration ? whitelabelConfiguration.display_name + ' Legal' : 'Syndesi' }}</span>
                    </h1>


                    <p class="text-white ">
                        To find a professional to assist you, please choose from one of our panel professionals
                        below, or search our pool of professionals using the "Find a Professional" button.
                    </p>

                    <!-- Calls to action -->
                    <!--            <router-link v-if="isAdvisor"-->
                    <!--                         to="/advisors/find-a-lawyer"-->
                    <!--                         class="btn btn-primary btn-lg rounded-pill w-100 w-lg-auto ms-auto mb-4">-->
                    <!--              <i class="fi-search me-2"></i>-->
                    <!--              Find a lawyer-->
                    <!--            </router-link>-->
                    <!-- / Calls to action -->

                    <!-- Stats -->
                    <!--            <stats></stats>-->
                    <!-- / Stats -->
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative bg-white rounded-xxl-4 zindex-5" style="margin-top: -30px;">
        <div class="container pt-5 pb-2 mb-4 mb-md-5 pb-5" style="padding-top: 50px !important;">

            <div class="row">
                <div class="col-md-12">

                    <!-- Lawyers We Recommend -->
                    <lawyers-we-recommend v-if="whitelabelConfiguration"></lawyers-we-recommend>
                    <!-- / Lawyers We Recommend -->

                    <!-- Can't find what you're looking for? -->
                    <div class="text-center mt-5">
                        <h2 class="text-center mb-4">Can't Find What You're Looking For?</h2>
                        <p class="text-center">
                            <router-link to="/guests/find-a-lawyer"
                                class="btn btn-primary btn-lg rounded-pill w-100 w-lg-auto ms-auto mb-4">
                                <i class="fi-search me-2"></i>
                                Find a Professional
                            </router-link>
                        </p>
                    </div>
                    <!-- / Can't find what you're looking for? -->

                </div>
            </div>

        </div>
    </section>
</template>
  
<script>
import Breadcrumb from '@/components/Breadcrumb'
import Spinner from "../components/Spinner";
import LawyersWeRecommend from "./Landing/LawyersWeRecommend.vue";
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Breadcrumb, Spinner, LawyersWeRecommend },
    data() {
        return {
        }
    },
    created() {
        if (this.loggedIn) {
            this.$router.push('/');
        }
    },
    methods: {
    },
    computed: {
        ...mapGetters('auth', {
            loggedIn: 'loggedIn'
        }),

        ...mapGetters('whitelabelConfiguration', {
            whitelabelConfiguration: 'whitelabelConfiguration'
        })
    },
    setup() {

    },
}
</script>
  
  
<style scoped lang="scss">
.text-primary {
    color: rgb(var(--primary-colour)) !important;
}
</style>